<app-frame
  [title]="'Enter Admin PIN'"
  (back)="onBack()"
>
  <!-- H1 -->
  <span  class="e174_22">Enter PIN to access admin panel.</span>

  <app-pin-entry
    (enter)="onEnter($event)"
  >

  </app-pin-entry>
</app-frame>
